module.exports = __webpack_public_path__ + "static/media/karen.e17e4d5f.svg";